import sha1 from 'js-sha1'
export function sign(data) {
  let arr = ["11H9TQZSA59IQTU4CIR3", data.timestamp, data.nonce];
  arr.sort(function (a, b) {
    return a - b;
  });
  let str = "";
  for (let i = 0;i < arr.length;++i) {
    str = str + arr[i];
  }
  return sha1(str);
}
export function getNonce(length) {
  let str = "zxcvbnmlkjhgfdsaqwertyuiopQWERTYUIOPASDFGHJKLZXCVBNM1234567890";
  let resStr = "";
  for(let i = 0; i < length; ++i) {
    let number = Math.floor(Math.random() * str.length);
    resStr = resStr + str[number];
  }
  return resStr;
}

/**
 * 获取浏览器类型，0-正常浏览器、1-闽政通、2-微信、3-支付宝
 */
export function getUserAgent() {
  const ua = navigator.userAgent;
  if (/mzt/.test(ua)) {
    return 1;
  } else if (/MicroMessenger/.test(ua)) {
    return 2;
  } else if (/AlipayClient/.test(ua)) {
    return 3;
  } else {
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js